var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",style:({ backgroundColor: _vm.color })},[_c('SuccessApplicationCard'),(_vm.utm_source === 'talent.com')?_c('img',{attrs:{"alt":"facebook-pixel","src":"https://ca.talent.com/tracker/img-pixel.php?tracker=recrutei","hidden":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }